/** Align with backend is_msp_agreement_service_type */
export function isMspAgreementServiceType(serviceTypeCode: string, serviceTypeName?: string | null): boolean {
  const c = (serviceTypeCode || '').trim().toLowerCase().replace(/-/g, '_');
  if (c === 'msp_agree' || c === 'msp_agreement') return true;
  const n = (serviceTypeName || '').trim().toLowerCase();
  return n === 'msp agreement';
}
